<template>
    <div class="account-form">
        <form @submit.prevent="store" class="account-form-container">
            <h2>{{ account ? $t('Редактирование') : $t('Новый счет') }}</h2>

            <multiselect :class="['color-picker', form.color_name]" v-model="form.color_name" :options="colors" :searchable="false" :show-labels="false">
                <template slot="singleLabel" class="color-signle-lable" slot-scope="props">
                    <div class="placeholder">
                        <i class="icon icon-accounts"></i>

                        <span>Change a color</span>
                    </div>
                </template>
                <template slot="option" slot-scope="props">
                    <div :class="['color-option', props.option]"></div>
                </template>
                <template slot="caret">
                    <div class="caret">
                        <i class="icon icon-chevron-down"></i>
                    </div>
                </template>
                <template slot="placeholder">
                    <div class="placeholder">
                        <i class="icon icon-accounts"></i>

                        <span>Pick a color</span>
                    </div>
                </template>
            </multiselect>

            <div class="form-group">
                <input type="text" v-model="form.title" :class="{'form-control account-name-input': true, 'is-invalid': hasError('title')}" :placeholder="$t('Введите название счета')">
            </div>
            <span class="invalid-feedback d-block" v-if="hasError('title')">{{ getError('title') }}</span>

            <div class="form-group">
                <multiselect 
                    :disabled="form.integrated"
                    v-model="form.type" 
                    :options="types" 
                    :allow-empty="false" 
                    :searchable="false" 
                    label="title" 
                    :show-labels="false" 
                    class="form-control">
                    <template slot="singleLabel" class="signle-lable" slot-scope="props">
                        <div class="label">
                            <span>{{ props.option.title }}</span>
                        </div>
                    </template>
                    <template slot="caret">
                        <div class="caret">
                            <i class="icon icon-chevron-down"></i>
                        </div>
                    </template>
                    <template slot="placeholder" slot-scope="props">
                        <div class="placeholder">
                            <span>Card type</span>
                        </div>
                    </template>
                </multiselect>
            </div>

            <div class="input-group">
                <input type="text" 
                    :disabled="form.integrated"
                    :class="{'form-control': true, 'is-invalid': hasError('amount')}" 
                    :placeholder="$t('Начальная сумма')" 
                    :value="form.amount != null ? form.amount / 100 : null"
                    @input="form.amount = parseInt($event.target.value * 100)">

                <multiselect 
                    :disabled="form.integrated"
                    v-model="form.currency" 
                    :options="currencies" 
                    :allow-empty="false" 
                    :searchable="false" 
                    label="name" 
                    :show-labels="false" 
                    class="form-control">
                    <template slot="singleLabel" class="signle-lable" slot-scope="props">
                        <div class="label">
                            <span>{{ props.option.name }}</span>
                        </div>
                    </template>
                    <template slot="caret">
                        <div class="caret">
                            <i class="icon icon-chevron-down"></i>
                        </div>
                    </template>
                    <template slot="placeholder" slot-scope="props">
                        <div class="placeholder">
                            <span>{{ $t('Валюта') }}</span>
                        </div>
                    </template>
                </multiselect>
            </div>
            <span class="invalid-feedback d-block" v-if="hasError('amount')">{{ getError('amount') }}</span>

            <div class="form-group" v-if="form.type && form.type.key == 'bank'">
                <input type="text" 
                    :class="{'form-control account-name-input': true, 'is-invalid': hasError('credit_limit')}" 
                    :placeholder="$t('Кредитный лимит')" 
                    :value="form.credit_limit != null ? form.credit_limit / 100 : null"
                    @input="form.credit_limit = parseInt($event.target.value * 100)">
            </div>
            <span class="invalid-feedback d-block" v-if="hasError('credit_limit')">{{ getError('credit_limit') }}</span>

            <div class="input-group my-24" v-if="form.type && form.type.key == 'bank'">
                <div class="checkbox-group mr-32">
                    <input id="card-mc" type="radio" name="card-system" v-model="form.card_system" value="mc">
                    <label for="card-mc" class="checkbox-label">
                        <svg width="39" height="24" viewBox="0 0 39 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M38.6082 19.386V18.9218H38.4868L38.3465 19.2406L38.2068 18.9218H38.0847V19.386H38.171V19.0359L38.3022 19.338H38.3915L38.5227 19.0352V19.386H38.6082ZM37.8383 19.386V19.0009H37.9939V18.9225H37.5972V19.0009H37.7528V19.386H37.8383Z" fill="#F79410"/>
                            <path d="M24.8127 21.3828H14.3124V2.56079H24.8127V21.3828Z" fill="#FF5F00"/>
                            <path d="M14.9852 11.9703C14.9852 8.15215 16.7775 4.75106 19.5686 2.55927C17.5275 0.95652 14.9516 -0.000104904 12.1521 -0.000104904C5.52451 -0.000104904 0.1521 5.35913 0.1521 11.9703C0.1521 18.5814 5.52451 23.9407 12.1521 23.9407C14.9516 23.9407 17.5275 22.984 19.5686 21.3813C16.7775 19.1895 14.9852 15.7884 14.9852 11.9703Z" fill="#EB001B"/>
                            <path d="M38.9744 11.9703C38.9744 18.5814 33.602 23.9407 26.9744 23.9407C24.1749 23.9407 21.599 22.984 19.5571 21.3813C22.349 19.1895 24.1413 15.7884 24.1413 11.9703C24.1413 8.15216 22.349 4.75107 19.5571 2.55928C21.599 0.95653 24.1749 -9.53674e-05 26.9744 -9.53674e-05C33.602 -9.53674e-05 38.9744 5.35914 38.9744 11.9703Z" fill="#F79E1B"/>
                        </svg>
                    </label>
                </div>
                <div class="checkbox-group">
                    <input id="card-visa" type="radio" name="card-system" v-model="form.card_system" value="visa">
                    <label for="card-visa" class="checkbox-label">
                        <svg width="70" height="23" viewBox="0 0 70 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0)">
                                <path d="M30.3333 22.6682H24.6628L28.2095 0.403564H33.8797L30.3333 22.6682Z" fill="#00579F"/>
                                <path d="M50.8893 0.947893C49.7709 0.4974 47.9969 0 45.8033 0C40.2035 0 36.2602 3.03162 36.236 7.36592C36.1895 10.5638 39.0593 12.3399 41.2057 13.4062C43.3996 14.4957 44.1453 15.2069 44.1453 16.1781C44.123 17.6696 42.3726 18.3572 40.74 18.3572C38.4761 18.3572 37.263 18.0027 35.4196 17.1729L34.6729 16.8171L33.8794 21.8151C35.2093 22.4302 37.6596 22.9761 40.2035 23C46.1534 23 50.027 20.0153 50.0729 15.3964C50.0955 12.8619 48.5801 10.9198 45.3131 9.33285C43.3298 8.31413 42.1152 7.62721 42.1152 6.58488C42.1385 5.6373 43.1425 4.66674 45.3813 4.66674C47.2248 4.6192 48.5792 5.06907 49.6053 5.51925L50.1181 5.75567L50.8893 0.947893Z" fill="#00579F"/>
                                <path d="M58.4259 14.7806C58.8929 13.5015 60.6898 8.55116 60.6898 8.55116C60.6663 8.59869 61.1559 7.24847 61.4359 6.41958L61.8322 8.33803C61.8322 8.33803 62.906 13.6674 63.1392 14.7806C62.2529 14.7806 59.5459 14.7806 58.4259 14.7806ZM65.4254 0.403564H61.0393C59.6867 0.403564 58.6591 0.805891 58.0755 2.25087L49.6527 22.6679H55.6026C55.6026 22.6679 56.5821 19.9199 56.7927 19.328C57.4454 19.328 63.2334 19.328 64.0731 19.328C64.2359 20.1097 64.7497 22.6679 64.7497 22.6679H70.0001L65.4254 0.403564Z" fill="#00579F"/>
                                <path d="M19.9266 0.403564L14.3733 15.5859L13.7665 12.5067C12.7398 8.9538 9.51988 5.0936 5.92664 3.17421L11.0132 22.6446H17.0096L25.9227 0.403564H19.9266Z" fill="#00579F"/>
                                <path d="M9.2166 0.403564H0.0933346L0 0.853427C7.11672 2.70105 11.83 7.15466 13.7664 12.5077L11.7832 2.27511C11.4566 0.853113 10.4532 0.450471 9.2166 0.403564Z" fill="#FAA61A"/>
                            </g>
                            <defs>
                                <clipPath id="clip0">
                                    <rect width="70" height="23" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                    </label>
                </div>
            </div>

            <div class="form-group">
                <input type="text" v-model="form.owner_name" :class="{'form-control account-name-input': true, 'is-invalid': hasError('owner_name')}" :placeholder="`${$t('Введите имя владельца')} (${$t('не обязательно')})`">
            </div>
            <span class="invalid-feedback d-block" v-if="hasError('owner_name')">{{ getError('owner_name') }}</span>

            <div class="form-group">
                <input type="text" v-model="form.card_number" :class="{'form-control account-name-input': true, 'is-invalid': hasError('card_number')}" :placeholder="`${$t('Номер карты')} (${$t('не обязательно')})`">
            </div>
            <span class="invalid-feedback d-block" v-if="hasError('card_number')">{{ getError('card_number') }}</span>

            <div class="checkbox-group mt-24 mb-5">
                <input :id="`balance-check-${account ? account.id : ''}`" v-model="form.is_count" type="checkbox">
                <label :for="`balance-check-${account ? account.id : ''}`" class="checkbox-label">
                    {{ $t('Учитывать в общем балансе') }}?
                </label>
            </div>

            <div class="info-tip" v-if="form.integrated">
                <p :title="$t('Помощь по привязке')">{{ $t('Данный счет привязан к банковской карте') }}</p>
            </div>

            <div class="info-tip" v-if="!account">
                <p>{{ $t('accounts_desc') }}.</p>
            </div>

            <div class="btn-group mt-10">
                <button type="button" v-if="account" @click="deleteAccount" class="btn btn-light">{{ $t('Delete') }}</button>

                <button type="submit" class="btn btn-form btn-blue">{{ account ? $t('Сохранить') : $t('Добавить') }}</button>
            </div>
        </form>
    </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import { EventBus } from '../../../event-bus';
import FormControlMultiSelect from "@/new/components/FormControlMultiSelect.vue";

export default {
    name: "AccountForm",

    components: {
        FormControlMultiSelect
    },

    props: ['isSideForm', 'account'],

    data: function() {
        return {
            form: {
                color_name: null,
                type: {'key': 'cash', title: this.$t('Наличные')},
                title: null,
                amount: null,
                owner_name: null,
                card_number: null,
                currency: {'key': 'uah', title: `₴ - ${this.$t('Гривна')}`},
                credit_limit: null,
                card_system: 'mc',
                is_count: true,
            },

            types: [
                {'key': 'cash', title: this.$t('Наличные')},
                {'key': 'bank', title: this.$t('Банковская карта')},
                {'key': 'deposit', title: this.$t('Депозит')}
            ],

            colors: [
                'color-gray',
                'color-white',
                'color-black',
                'color-rose',
                'color-blue',
                'color-green',
                'color-yellow',
                'color-red'
            ],

            errors: {},
        };
    },

    mounted() {
        if(this.account) {
            this.form = Object.assign({}, this.account);

            let type = this.types.filter((type) => type.key == this.account.type)[0];

            this.form.type = type ? type : {'key': 'cash', title: this.$t('Наличные')};
        } else {
            this.form.currency = this.currency;
        }
    },

    computed: {
        ...mapGetters(['currency', 'currencies']),
    },
    
    methods: {
        ...mapActions(['loadAccounts']),

        store() {
            if(this.account) {
                return this.save();
            }

            axios.post('/accounts', this.form)
                .then(({data}) => {
                    this.closeForm();
                    this.loadAccounts();

                    this.form = {
                        color: null,
                        type: {'key': 'cash', title: this.$t('Наличные')},
                        title: null,
                        amount: null,
                        owner_name: null,
                        card_number: null,
                        currency: {'key': 'uah', title: `₴ - ${this.$t('Гривна')}`},
                        credit_limit: null,
                        card_system: 'mc',
                        is_count: true,
                        integrated: false,
                    };

                    return EventBus.$emit('show-alert', data.message ? data.message : $t('Напоминание успешно создано'), 'success'); 
                }).catch(({response}) => {
                    console.log(response);
                    
                    if(response.status !== 422) {
                        return EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Неизвестная ошибка'), 'error');   
                    }

                    this.errors = response.data.data;
                });
        },

        save() {
            axios.patch(`/accounts/${this.account.id}`, this.form)
                .then(({data}) => {
                    this.closeForm();
                    this.loadAccounts();

                    return EventBus.$emit('show-alert', data.message ? data.message : $t('Изменения сохранены'), 'success'); 
                }).catch(({response}) => {
                    console.log(response);
                    
                    if(response.status !== 422) {
                        return EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Неизвестная ошибка'), 'error');   
                    }

                    this.errors = response.data.data;
                });
        },

        deleteAccount() {
            axios.delete(`/accounts/${this.account.id}`)
                    .then(({data}) => {
                        this.closeForm();
                        this.loadAccounts();
                    }).catch(({response}) => {
                        console.log(response);
                    
                        if(response.status !== 422) {
                            return EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Неизвестная ошибка'), 'error');   
                        }

                        this.errors = response.data.data;
                    });
        },

        closeForm() {
            EventBus.$emit('close-side-form');
        },
        
        hasError(name) {
            return this.errors[name] !== undefined;
        },
        
        getError(name) {
            if(this.hasError(name)) {
                return this.errors[name][0].replace(name, '');
            }

            return "";
        },
    }
}
</script>

<style scoped lang="scss">
.account-form-container {
    background: #fff;
    width: calc(100% - 64px);
    border-radius: 5px;
    margin-bottom: 24px;
    padding: 24px 32px;

    @media (max-width: 768px) {
        background: transparent;
        padding: 0 24px;
        width: calc(100% - 48px);
        display: flex;
        flex-direction: column;
        height: 100%;

        .btn-form {
            margin-top: auto;
            margin-bottom: 24px;
        }
    }

    h2 {
        font-size: 18px;
        font-family: 'Proxima Nova Lt';
        font-weight: 600;
        color: #152640;
        margin: 0;
        margin-bottom: 18px;
    }

    .account-name-input {
        width: calc(100% - 24px);
    }

    .input-group {
        display: flex;
        align-items: center;

        .form-control {
            margin: 6px 8px;

            &:first-child {
                margin-left: 0;
            }

            &:last-child {
                margin-right: 0;
            }
        }
    }

    .info-tip {
        font-size: 12px;
        font-family: 'Proxima Nova Rg';
        color: rgba(#152640, .5);
    }
}
</style>